import { AttachmentResponse, WebAssetResponse } from "@akitabox/api-client";

import { buildAssetHeader, formatDate } from "./common";

export function singleImage(
  asset: WebAssetResponse,
  attachment?: AttachmentResponse
) {
  return (
    <table className="ck-table-resized">
      <colgroup>
        <col style={{ width: "100%" }} />
      </colgroup>
      <tbody>
        {buildAssetHeader(asset)}
        {attachment && (
          <tr>
            <td>
              <figure
                className="image image_resized image-style-align-center"
                style={{ width: "100%" }}
              >
                <img src={attachment.document.public_thumbnail_url_large} />
                <figcaption>
                  {formatDate(
                    attachment.document.last_mod_date ||
                      attachment.document.cre_date
                  )}
                </figcaption>
              </figure>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
